const onboardingRoutes = [
  {
    path: '/:programmeId',
    name: 'OnboardingPage',
    component: () => import('@/components/onboarding-components/OnboardingPage.vue')
  },
  {
    path: '/invalid/:programmeId?/',
    name: 'Invalid',
    component: () => import('@/components/onboarding-components/OnboardingInvalidPage.vue')
  },
  {
    path: '/style-guide',
    name: 'StyleGuide',
    component: () => import('@/components/style-guide-components/StyleGuide.vue')
  }
]

export default onboardingRoutes
